"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Param = Param;
exports.Singular = Singular;
exports.Plural = Plural;
exports.makeComponents = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["children", "context", "as"],
    _excluded2 = ["children", "count", "context", "as"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function Param(_ref) {
  var wrapper = _ref.wrapper,
      value = _ref.value,
      children = _ref.children;
  return wrapper ? _react.default.cloneElement(wrapper, {}, value !== undefined ? value : children) : value;
}

Param.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.any,
  wrapper: _propTypes.default.element,
  children: _propTypes.default.string
};
Param.defaultProps = {
  value: undefined,
  wrapper: undefined,
  children: undefined
};

var collapseWhitespace = function collapseWhitespace(string) {
  // for translated strings we never want consecutive or surrounding whitespace
  return string.replace(/\s+/g, ' ').trim();
};

var getTranslatableString = function getTranslatableString(children) {
  var usedParams = new Set();

  var items = _react.default.Children.map(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      // plain value, nothing to change here
      if (typeof child !== 'string') {
        throw new Error("Unexpected Translate child type: ".concat(_typeof(child)));
      }

      return child;
    } else if (child.type !== Param) {
      throw new Error("Translate child components must be of type Param; got ".concat(child.type.name));
    } else {
      var _child$props = child.props,
          paramName = _child$props.name,
          paramValue = _child$props.value;
      var paramContent = child.props.children;

      if (usedParams.has(paramName)) {
        throw new Error("Translate params must be unique; found ".concat(paramName, " more than once"));
      } else if (Array.isArray(paramContent)) {
        paramContent = paramContent.join('');
      } else if (paramContent !== undefined && typeof paramContent !== 'string') {
        throw new Error("Unexpected Param child type: ".concat(_typeof(paramContent)));
      } else if (paramContent === undefined && paramValue === undefined) {
        throw new Error("Param has no value nor children");
      }

      usedParams.add(paramName);
      return paramContent === undefined ? "{".concat(paramName, "}") : "{".concat(paramName, "}").concat(paramContent, "{/").concat(paramName, "}");
    }
  });

  return collapseWhitespace(items.join(''));
};

var jsonToReact = function jsonToReact(values, component, props) {
  /* eslint-disable react/prop-types */
  component = {
    Fragment: _react.default.Fragment,
    Param: Param
  }[component];

  if (component === Param) {
    // inject the value from the original Param in the translated string's Param
    props = _objectSpread(_objectSpread({}, props), values[props.name]);
  }

  for (var _len = arguments.length, children = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    children[_key - 3] = arguments[_key];
  }

  return _react.default.createElement.apply(_react.default, [component, props].concat(_toConsumableArray(children.map(function (child) {
    return typeof child === 'string' ? child : jsonToReact.apply(void 0, [values].concat(_toConsumableArray(child)));
  }))));
};

var renderTranslation = function renderTranslation(translation, values) {
  if (typeof translation === 'string') {
    return translation;
  } else {
    return jsonToReact.apply(void 0, [values].concat(_toConsumableArray(translation)));
  }
};

var jsonToText = function jsonToText(values, component, props) {
  for (var _len2 = arguments.length, children = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    children[_key2 - 3] = arguments[_key2];
  }

  if (component === 'Param') {
    if (children.length) {
      throw new Error('Placeholders with content are not supported in string()');
    } else {
      if (!Object.prototype.hasOwnProperty.call(values, props.name)) {
        throw new Error("Placeholder '{".concat(props.name, "}' got no value"));
      }

      return values[props.name];
    }
  }

  return children.map(function (child) {
    return typeof child === 'string' ? child : jsonToText.apply(void 0, [values].concat(_toConsumableArray(child)));
  }).join('');
};

var interpolateValues = function interpolateValues(string, values) {
  return string.replace(/{([^}]+)}/g, function (match, name) {
    if (!Object.prototype.hasOwnProperty.call(values, name)) {
      throw new Error("Placeholder '{".concat(name, "}' got no value"));
    }

    return values[name];
  });
};

var renderStringTranslation = function renderStringTranslation(translation, values) {
  if (typeof translation === 'string') {
    return interpolateValues(translation, values);
  } else {
    return jsonToText.apply(void 0, [values].concat(_toConsumableArray(translation)));
  }
};

function Singular(_ref2) {
  var children = _ref2.children;
  return children;
}

Singular.propTypes = {
  children: _propTypes.default.any.isRequired
};

function Plural(_ref3) {
  var children = _ref3.children;
  return children;
}

Plural.propTypes = {
  children: _propTypes.default.any.isRequired
};

var getGettextFuncs = function getGettextFuncs(jedInstance) {
  var gettext = jedInstance.gettext.bind(jedInstance);
  var ngettext = jedInstance.ngettext.bind(jedInstance);
  var pgettext = jedInstance.pgettext ? jedInstance.pgettext.bind(jedInstance) : undefined;
  var npgettext = jedInstance.npgettext ? jedInstance.npgettext.bind(jedInstance) : undefined;

  if (!pgettext) {
    pgettext = function pgettext(ctx) {
      for (var _len3 = arguments.length, params = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        params[_key3 - 1] = arguments[_key3];
      }

      return gettext.apply(void 0, params);
    };
  }

  if (!npgettext) {
    npgettext = function npgettext(ctx) {
      for (var _len4 = arguments.length, params = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        params[_key4 - 1] = arguments[_key4];
      }

      return ngettext.apply(void 0, params);
    };
  }

  return {
    gettext: gettext,
    ngettext: ngettext,
    pgettext: pgettext,
    npgettext: npgettext
  };
};

var pickGettextFunc = function pickGettextFunc(context, gettext, pgettext) {
  if (context) {
    return function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return pgettext.apply(void 0, [context].concat(args));
    };
  } else {
    return gettext;
  }
};

var getParamValues = function getParamValues(element) {
  var obj = Object.create(null);

  _react.default.Children.forEach(element.props.children, function (child) {
    if (_react.default.isValidElement(child) && child.type === Param) {
      obj[child.props.name] = {
        value: child.props.value,
        wrapper: child.props.wrapper
      };
    }
  });

  return obj;
};

var getContextParams = function getContextParams(args) {
  if (args.length === 0) {
    return {
      context: undefined,
      params: {}
    };
  } else if (args.length === 1) {
    if (_typeof(args[0]) === 'object') {
      return {
        context: undefined,
        params: args[0]
      };
    } else {
      return {
        context: args[0],
        params: {}
      };
    }
  } else {
    return {
      context: args[0],
      params: args[1]
    };
  }
};

var getNPlurals = function getNPlurals(jedInstance) {
  var _localeData$domain, _localeData$domain$;

  var _ref4 = jedInstance.options || {},
      domain = _ref4.domain,
      localeData = _ref4.locale_data;

  var pluralForms = localeData === null || localeData === void 0 ? void 0 : (_localeData$domain = localeData[domain]) === null || _localeData$domain === void 0 ? void 0 : (_localeData$domain$ = _localeData$domain['']) === null || _localeData$domain$ === void 0 ? void 0 : _localeData$domain$.plural_forms;

  if (!pluralForms) {
    return null;
  }

  var match = pluralForms.match(/^nplurals=(\d+)/);

  if (!match) {
    return null;
  }

  return Number(match[1]);
};

var makeComponents = function makeComponents(jedInstance) {
  var _getGettextFuncs = getGettextFuncs(jedInstance),
      gettext = _getGettextFuncs.gettext,
      ngettext = _getGettextFuncs.ngettext,
      pgettext = _getGettextFuncs.pgettext,
      npgettext = _getGettextFuncs.npgettext;

  var nPlurals = getNPlurals(jedInstance);

  function Translate(_ref5) {
    var children = _ref5.children,
        context = _ref5.context,
        as = _ref5.as,
        rest = _objectWithoutProperties(_ref5, _excluded);

    var original = (0, _react.useMemo)(function () {
      return getTranslatableString(children);
    }, [children]);
    var gettextFunc = pickGettextFunc(context, gettext, pgettext);
    var translation = gettextFunc(original);
    var content = children;

    if (translation !== original) {
      content = renderTranslation(translation, getParamValues({
        props: {
          children: children
        }
      }));
    } // if there's no translation gettext gives us the input string
    // which does not contain the information needed to render it!
    // unfortunately this means that we also cannot strip surrounding
    // whitespace since we may have more than just text in the children,
    // which is why we fail during extraction in that case


    return _react.default.createElement(as, rest, content);
  }

  Translate.string = function string(original) {
    for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      args[_key6 - 1] = arguments[_key6];
    }

    var _getContextParams = getContextParams(args),
        context = _getContextParams.context,
        params = _getContextParams.params;

    var gettextFunc = pickGettextFunc(context, gettext, pgettext);
    return renderStringTranslation(gettextFunc(collapseWhitespace(original)), params);
  };

  Translate.propTypes = {
    children: _propTypes.default.any.isRequired,
    context: _propTypes.default.string,
    as: _propTypes.default.elementType
  };
  Translate.defaultProps = {
    context: undefined,
    as: _react.default.Fragment
  };

  function PluralTranslate(_ref6) {
    var children = _ref6.children,
        count = _ref6.count,
        context = _ref6.context,
        as = _ref6.as,
        rest = _objectWithoutProperties(_ref6, _excluded2);

    var _useMemo = (0, _react.useMemo)(function () {
      var singular, plural;

      _react.default.Children.forEach(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          throw new Error("Unexpected PluralTranslate child: ".concat(child));
        } else if (child.type === Singular) {
          singular = getTranslatableString(child.props.children);
        } else if (child.type === Plural) {
          plural = getTranslatableString(child.props.children);
        }
      });

      return [singular, plural];
    }, [children]),
        _useMemo2 = _slicedToArray(_useMemo, 2),
        singularString = _useMemo2[0],
        pluralString = _useMemo2[1];

    function getChild(plural) {
      var component = plural ? Plural : Singular;

      var _iterator = _createForOfIteratorHelper(_react.default.Children.toArray(children)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;

          if (_react.default.isValidElement(child) && child.type === component) {
            return child;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    var gettextFunc = pickGettextFunc(context, ngettext, npgettext);
    var translation = gettextFunc(singularString, pluralString, count);
    var content;

    if (translation === singularString) {
      content = getChild(false);
    } else if (translation === pluralString) {
      content = getChild(true);
    } else {
      // For languages with only one plural, the plural translation is
      // used even if count == 1. In that case the corresponding <Plural>
      // component must be rendered.
      var plural = nPlurals === 1 || count !== 1;
      var values = getParamValues(getChild(plural));
      content = renderTranslation(translation, values);
    }

    return _react.default.createElement(as, rest, content);
  }

  PluralTranslate.propTypes = {
    children: _propTypes.default.any.isRequired,
    count: _propTypes.default.number.isRequired,
    context: _propTypes.default.string,
    as: _propTypes.default.elementType
  };
  PluralTranslate.defaultProps = {
    context: undefined,
    as: _react.default.Fragment
  }; // eslint-disable-next-line no-shadow

  PluralTranslate.string = function string(singular, plural) {
    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    for (var _len7 = arguments.length, args = new Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
      args[_key7 - 3] = arguments[_key7];
    }

    var _getContextParams2 = getContextParams(args),
        context = _getContextParams2.context,
        params = _getContextParams2.params;

    var gettextFunc = pickGettextFunc(context, ngettext, npgettext);
    return renderStringTranslation(gettextFunc(collapseWhitespace(singular), collapseWhitespace(plural), count), params);
  };

  return {
    Translate: Translate,
    PluralTranslate: PluralTranslate
  };
};

exports.makeComponents = makeComponents;